import React from 'react';
import { useParams } from 'react-router-dom';
import VariantOptionForm from '../../Components/VariantOptions/VariantOptionForm';

/**
 * Component for adding a new variant option
 * @returns {JSX.Element} VariantOptionAdd component
 */
const VariantOptionAdd = () => {
  const { lng } = useParams();
  
  return <VariantOptionForm lng={lng} />;
};

export default VariantOptionAdd;
